module.exports = __webpack_public_path__ + "static/media/help.51e4e97f.png";